// Vite injects import.meta.env at build/runtime; plain Node (unit tests) has no
// import.meta.env — fall back to {} so the module loads in both. Behaviour in
// the browser is unchanged (import.meta.env is always the real object there).
const ENV = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {}

// Build-time feature scope.
//
// FOURBALL_ONLY strips the app down to ONLY the 4-Ball tournament workflow
// (registration/rosters, qualifying, build, live scoring, leaderboard+brackets,
// TV boards, GPS map, AI assistant, plus Calcutta/Photos/Contests). Everything
// else — Admin Portal landing card, History, the Pro Shop / retail suite,
// non-4-Ball formats, Weather, the Calculator, Demos & Practice — is removed
// (not rendered, not routed — truly gone, not CSS-hidden).
//
// NOTE: VITE_FOURBALL_ONLY=true is set in BOTH .env.mine.local (pbcc-tourney-test)
// AND .env.theirs.local (pbcc-tourney, the club). So FOURBALL_ONLY is NOT a
// test-only flag — it's true on the club too. Live (completetourneylive) leaves
// it unset (stays FULL-featured even on rebuild).
export const FOURBALL_ONLY = ENV.VITE_FOURBALL_ONLY === 'true'

// GGC_ONLY strips the app to the standalone Golf Game Central page (the real
// GFeaturesHub + games, in the branded frame, sidebar reduced to only Golf Game
// Central, NO gate). Set only in .env.ggc.local (the throwaway test site). Every
// other build (incl. pinebluffcc --mode tourney) leaves it false → unaffected.
// HUSTLER = the Golf Hustler build (VITE_HUSTLER=true, set only in
// .env.hustler.local → deployed to the golfhustler site). It's the GGC
// standalone app RESKINNED: white cards (no cream), NO Pine Bluff branding, a
// Golf Hustler hero, and no members-access-code gate (Apple+Google sign-in comes
// later). It reuses the entire GGC surface, so HUSTLER implies GGC_ONLY.
export const HUSTLER = ENV.VITE_HUSTLER === 'true'
export const GGC_ONLY = ENV.VITE_GGC_ONLY === 'true' || HUSTLER

// TRUE only on the TEST site (pbcc-tourney-test). IS_TEST_SITE now gates ONLY
// things that must NEVER reach production: the test PIN (PinGate) and the debug
// vanish tripwire (qeAudit). All UI/feature work uses PBCC_PREMIUM below.
export const IS_TEST_SITE = String(ENV.VITE_FIREBASE_DATABASE_URL || '').includes('pbcc-tourney-test')

// TRUE on the premium PBCC sites — the TEST copy (pbcc-tourney-test), the LIVE
// club site (completetourneylive / pbccgolf.com), AND the big full-featured site
// (yesnetlabs-tourney). Gate for the full premium restyle (gold/cream/deep-green
// theme + 4-Ball feature set). THEIRS (pbcc-tourney, the empty copy) stays
// non-premium. NOTE: yesnetlabs runs the FULL app (FOURBALL_ONLY=false) with the
// premium theme — so premium styling must NOT assume FOURBALL_ONLY.
export const PBCC_PREMIUM =
  String(ENV.VITE_FIREBASE_DATABASE_URL || '').includes('pbcc-tourney-test') ||
  String(ENV.VITE_FIREBASE_DATABASE_URL || '').includes('completetourneylive') ||
  String(ENV.VITE_FIREBASE_DATABASE_URL || '').includes('yesnetlabs-tourney')

// Active brand (build-time). Golf Elite is the platform DEFAULT brand. An
// explicit VITE_BRAND always wins; otherwise Golf Hustler and PBCC are
// auto-detected from their EXISTING build signals so those builds are 100%
// unchanged (no env edits needed), and any build without a PBCC/Hustler signal
// falls back to 'golf-elite'. The Golf Elite build sets VITE_BRAND=golf-elite so
// it is explicit even when it reuses a PBCC_PREMIUM database for preview.
export const BRAND_ID =
  ENV.VITE_BRAND ||
  (HUSTLER
    ? 'hustler'
    : (PBCC_PREMIUM || FOURBALL_ONLY || GGC_ONLY)
      ? 'pbcc'
      : 'golf-elite')

export const IS_GOLF_ELITE = BRAND_ID === 'golf-elite'
